export enum TechnicalDelegationPointName {
  START = 'start',
  END = 'end',
  DELEGATION_END = 'delegation-end',
}
